import Module from './builders/Module'

let options = new Module()

options.addState({ options: {} })
  .addGetters({
    options: state => state.options
  })
  .addActions({
    setOptions: ({ commit }, options) => commit('options', options)
  })
  .addMutations({
    options: (state, options) => (state.options = options)
  })

export default options
